<script>
import FooterSection from "../../package/footerSection.vue";
import PropertyIconSet from "../../package/propertyIconSet.vue";
import BreadcrumbSection from "../../package/breadcrumbSection.vue";
import ConfirmationSelection from "../confirmationSelection.vue";
import AdvertisementSection from "../advertisementSection.vue";
import AgentSignInSection from "../../package/agentSignInSection.vue";
import ReservationFormSection from "../reservationFormSection.vue";
import DrawerAside from "../../package/DrawerAside.vue";
import HeaderSection from "../../package/HeaderSection.vue";
import { mapActions } from "vuex";

export default {
  name: "selectionFormLayout",
  components: {
    HeaderSection,
    ReservationFormSection,
    AgentSignInSection,
    AdvertisementSection,
    ConfirmationSelection,
    BreadcrumbSection,
    PropertyIconSet,
    FooterSection,
    DrawerAside
  },
  beforeUpdate() {
    document.title =
      "UNIFI Property: Reserve Property (" + this.$route.query.pid + ")";
  },
  data() {
    return {
      adPage: "U-Display Listings Page",
      adSuburbs: "",
      adsData: "",
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D",
      showFootTxt: true,
      haveSign: false,
      checked: false, // Whether to select or not. If selected, it is not required.
      cardType: "",
      item: {},
      user: {},
      url:
        "https://account.docusign.com/oauth/auth?\
response_type=code\
&scope=signature\
&client_id=53616529-a161-4983-9876-39627b6d76f2\
&redirect_uri=https://unifiproperty.com/",
      signwarn: false,
      showTitle: false,
      gray: true,
      num: 1,
      disable: true,
      signSurName: false,
      signmiddleName: false,
      signFirName: false,
      allPurchaser: [
        {
          purchaserId: 1,
          title: "",
          titleWarn: false,
          open: false,
          state: "",
          stateWarn: false,
          openState: false,
          firstName: "",
          fristWarn: false,
          middleName: "",
          midWarn: false,
          surName: "",
          surWarn: false,
          address: "",
          addressWarn: false,
          suburb: "",
          suburbWarn: false,
          mobile: "",
          mobileWarn: false,
          email: "",
          postcode: "",
          postcodeWarn: false,
          emailwarn: false
        }
      ],
      legal: {
        companyName: "",
        companyWarn: false,
        person: "",
        personWarn: false,
        address: "",
        addressWarn: false,
        suburb: "",
        suburbWarn: false,
        state: "",
        stateWarn: false,
        postcode: "",
        postcodeWarn: false,
        openState: false,
        email: "",
        emailWarn: false,
        mobile: "",
        mobileWarn: false,
        phone: "",
        phoneWarn: false
      },
      cardInfo: {
        cardName: "",
        cardNameWarn: false,
        cardNumber: "",
        cardNumberWarn: false,
        cardCvv: "",
        cardCvvWarn: false,
        cardMonth: "",
        cardYear: "",
        cardDate: false
      },
      agreementDate: "",
      agreementDateWarn: false,
      agreementName: "",
      agreementNameWarn: false,
      purchasingEntity: "",
      promisePurchaser: null,
      promiseLegal: null,
      promiseOther: null
    };
  },
  created() {
    localStorage.removeItem("email");
    localStorage.removeItem("fname");
    localStorage.removeItem("sname");
    localStorage.removeItem("id");
    var that = this;
    that.getPropertyDtl({
      params: { id: that.$route.query.pid, roomId: that.$route.query.rid },
      callback: that.callback
    });
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
    this.getAdsbyPageAndSuburb();
  },
  beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave called - selectionformlayout");
    this.$refs.$reservationFormSectionRef.destroy();
    next();
  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  },
  methods: {
    ...mapActions("property", [
      "getPropertyDtl",
      "submitInfo",
      "getType",
      "getSignUrl"
    ]),
    ...mapActions("account", ["getUserDtl"]),
    ...mapActions("home", ["getAds"]),
    spread() {
      this.unfold = true;
    },
    fold() {
      this.unfold = false;
    },
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        var datum = res.data.data;
        if (datum.imageUrl.indexOf(",") !== -1) {
          datum.imgLst = datum.imageUrl.split(",");
        } else {
          datum.imgLst = [datum.imageUrl];
        }
        datum.rental = that.$box.formatSplit(datum.rental, true);
        datum.maxRental =
          datum.maxRental !== 0
            ? that.$box.formatSplit(datum.maxRental, true)
            : null;
        datum.commision = that.$box.formatSplit(
          parseInt(datum.commision),
          true
        );
        datum.price = that.$box.formatSplit(datum.price, true);
        datum.maxPrice = that.$box.formatSplit(datum.maxPrice, true);
        datum.landPrice =
          datum.landPrice !== ""
            ? that.$box.formatSplit(datum.landPrice, true)
            : "";
        datum.buildPrice =
          datum.buildPrice !== ""
            ? that.$box.formatSplit(datum.buildPrice, true)
            : "";
        that.item = datum;
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    userCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.user = res.data.data;
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 8902 ||
        res.data.code == 8901
      ) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    getAdsbyPageAndSuburb() {
      let body_params = {
        adPage: this.adPage,
        adSuburbs: this.adSuburbs
      };
      this.getAds({
        params: { other: body_params },
        callback: this.callbackAds
      });
    },
    callbackAds(resp) {
      if (resp.data.code == 0) {
        this.adsData = resp.data.data;
      } else {
      }
    }
  }
};
</script>

<template>
  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible;">
        <reservation-form-section
          ref="$reservationFormSectionRef"
          :listing-details="this.item"
        />
        <advertisement-section
          :adLink="adsData.propertyReservation2Click"
          :adUrl="adsData.propertyReservation2"
        />
        <property-icon-set />
        <agent-sign-in-section style="padding-bottom: 40px" />
      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #ffffff;
}

.el-switch /deep/ .el-switch__label--left {
  color: #ffffff;
  /* color: #2D2D2D; */
}

.el-switch /deep/ .el-switch__label--right {
  color: #ffffff;
}

.el-switch /deep/ .el-switch__core:after {
  background-color: var(--switch-color);
}
</style>



// WEBPACK FOOTER //
// src/components/reservation/form/selectionFormLayout.vue